<div class="wrapper" [class.show-animations]="showAnimations">

  <p class="gl-params-selected" *ngIf="showChangedCount">
    <span i18n>Выбрано: </span>
    <span>{{selectedItems.length}}</span>
    <a *ngIf="selectedItems.length" i18n (click)="removeAll()">
      Удалить все
    </a>
  </p>

  <div class="chips-list" *ngIf="showChips && selectedItems.length">
    <div class="chips-list__item" *ngFor="let item of selectedItems">
      <p *ngIf="!limitChipsName">{{ item.name }}</p>
      <p *ngIf="limitChipsName">{{ item.name | limitText:limitChipsName }}</p>
      <button (click)="removeChips(item)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <label (click)="fieldClick(true)" #labelElement
         [ngClass]="{'gl-border-error': invalid, 'focus': _showPanel }">
    <span class="field-label" *ngIf="label">{{ label }}</span>
    <span class="gl-d-flex">
    <input
      type="text"
      spellcheck="false"
      [placeholder]="placeholder"
      [formControl]="searchControl"
    />

    <span class="trigger" (click)="iconClick($event)"
          [class.center-pos]="label">
      <mat-icon>
        {{
          clearSearchTermAndSelection
            ? selectedItems.length || searchControl.value ? 'close' : triggerIcon
            : searchControl.value ? 'close' : triggerIcon
        }}
      </mat-icon>
    </span>
  </span>
  </label>

  <button class="menu-trigger" [matMenuTriggerFor]="panelMenu"
          #panelMenuTrigger="matMenuTrigger">
  </button>

  <mat-menu class="multiple-select-menu" #panelMenu (close)="_showPanel = false">
    <div class="panel" (click)="stopEvent($event)" [style.width.px]="labelElement.clientWidth">
      <ng-container *ngIf="list$ | async as list; else spinner">
        <ng-container *ngIf="isLoading">
          <ng-container *ngTemplateOutlet="spinner"></ng-container>
        </ng-container>
        <mat-option class="mat-option-multiple" *ngIf="!isLoading && searchHasBeenDone && list.length === 0">
          <span i18n>Ничего не найдено</span>
        </mat-option>
        <mat-option *ngFor="let item of list" [value]="item" class="mat-option-multiple">
          <mat-checkbox color="primary" [ngModel]="item.selected"
                        (change)="checkboxChange($event, item)">
            <span [matTooltip]="item.name"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="400"
                  [matTooltipDisabled]="item.name.length <= limitOptionText">
              {{ item.name | limitText:limitOptionText }}
            </span>
          </mat-checkbox>
        </mat-option>
      </ng-container>
    </div>
  </mat-menu>

</div>

<ng-template #spinner>
  <div class="spinner-wrapper">
    <app-spinner [size]="'2.5rem'"></app-spinner>
  </div>
</ng-template>
